import dynamic from "next/dynamic";

export const BlogPostCard = dynamic(() => import("./component"));
